export const videoExt = ["mp4"];
export const docExt = ["pdf", "doc"];
export const imgExt = ["png", "jpeg", "jpg"];